export default {
  setGoodLines(state, value) {
    state.goodLines = value
  },
}
